/// <reference path="../../../vendor/typings/angularjs/angular.d.ts" />
/// <reference path="../universal-storage/universal.storage.model.ts" />


module Eseebase {

    export class ModelCreatorProjectModel {
        fileId: string;
        localizer: string;
        drawings: ModelCreatorDrawingModel[];
        constructor() {
            this.drawings = [];
        }
    }
    
    export class ModelCreatorDrawingModel {
        drawingType: string;
        floorLevel: number | null;
        drawingUrl: string;
        tags: string[];
    }

    export class ModelCreatorViewModel extends UniversalStorageViewModel {
        drawingType: string;
        floorLevel: number | null;
        constructor() {
            super();
        }
    }

    export class ModelCreatorPagedResult {
        totalNumberOfPages: number;
        totalNumberOfRecords: number;
        pageSize: number;
        results: ModelCreatorViewModel[];
        isLoading: boolean;
        pageNumber: number;
        scrollId: string;
        isLastPage: boolean;
        constructor() {
            this.results = [];
            this.totalNumberOfRecords = -1;
            this.pageSize = 10;
            this.pageNumber = 1;
            this.totalNumberOfPages = 10;
            this.isLastPage = false;
        }
    }
}